export default "__VITE_ASSET__uxt1$AWI__"